import styled from 'styled-components';
import { HIGHLIGHT_AND_CONTENT_EDITING_BEHAVIOR_CSS } from 'common/components/TouchpointEditor/components/TouchpointContainer'; // eslint-disable-line max-len
import { SpeakerImagesContainer } from 'common/components/SessionCard/SessionCard.styles';
import { media } from 'common/styles/breakpoints';

export const SpeakerInformationContainer = styled.div`
    ${HIGHLIGHT_AND_CONTENT_EDITING_BEHAVIOR_CSS}
`;

export const RightAlignedSpeakerImages = styled(SpeakerImagesContainer)`
    justify-content: flex-start;

    ${media.medium`
        justify-content: flex-end;
    `}
`;

export const SingleSpeakerInformationText = styled.div`
    text-align: left;

    ${media.medium`
        text-align: right;
    `}
`;
